
import * as api from './api';
import { CrudApiService, CrudServiceProps } from "../ApiCrudService";

export const DomainCrudService = function(props: 
  CrudServiceProps<api.Domain,string>
) {
  
  return CrudApiService<api.Domain,string>({...props, api: api, entityName: 'Domain'});

};